<yrx-spacing type="XL2"></yrx-spacing>
<footer #footer class="footer">
  <yrx-spacing type="L"></yrx-spacing>
  <div class="container flex flex_column gap-24">
    <div class="flex flex_justify-between">
      <div [routerLink]="'/platform'" class="logotype flex gap-12 flex_align-center">
        <yrx-icon [hover]="false" color="purple-100" icon="yurelax"></yrx-icon>
        <h1 class="headline c-gradation-100">yurelax</h1>
      </div>
      <yrx-button (click)="scrollTop()" type="secondary">
        <span>Вернуться наверх</span>
        <yrx-ref-icon class="stroke" name="arrow-up" btn-right-icon></yrx-ref-icon>
      </yrx-button>
    </div>
    <div class="separator"></div>
    <div class="flex flex_align-center flex_justify-between">
      <ul class="socials" aria-label="Социальные сети Yurelax">
        @for (social of socials; track social.link) {
          @if (social.link) {
            <li>
              <a
                [href]="social.link"
                target="_blank"
                rel="noopener noreferrer"
                class="social-link text text_body medium"
                [attr.aria-label]="social.name + ' — откроется в новой вкладке'"
              >
                <span class="social-icon" [style.--social-color]="social.color" aria-hidden="true">
                  <yrx-icon [hover]="false" [icon]="social.icon"></yrx-icon>
                </span>
                <span>{{social.name}}</span>
              </a>
            </li>
          }
        }
      </ul>
      <ul class="flex gap-24">
        <li><span class="pending-link text text_body medium" title="Документ готовится">Условия пользования</span></li>
        <li><span class="pending-link text text_body medium" title="Документ готовится">Политика конфиденциальности</span></li>
      </ul>
    </div>
  </div>
  <yrx-spacing type="L"></yrx-spacing>
</footer>
